import { BehaviorSubject, Observable } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SnToastsService {
  public closeToasts: boolean = false;

  private readonly _isOnMap$ = new BehaviorSubject(false);

  constructor() {}

  get isOnMap$(): Observable<boolean> {
    return this._isOnMap$.asObservable();
  }

  get value(): boolean {
    return this._isOnMap$.value;
  }

  public setValue(value: boolean): void {
    this._isOnMap$.next(value);
  }
}
